export default __webpack_public_path__ + "static/blob-23-2622dd8b9cb18d50b2892ec3c6f6e6c2.svg";